import { compose } from "recompact"
import * as entity from "src/engine/modules/entity"
import planTypeModel from "src/models/planType"
import collection from "src/hocs/collection"

export default config =>
  compose(
    collection({
      engine: entity,
      to: `planTypes`,
      model: planTypeModel,
      query: {
        limit: -1,
        orderBy: `name asc`,
      },
      ...config,
    }),
  )
